const { default: HomeDashboardRoute } = require("./HomeDashboard/HomeDashboardRoute");
const { default: NotFoundRoute } = require("./NotFound/NotFoundRoute");

export default { HomeDashboardRoute, NotFoundRoute }